<!--
 * @Date: 2022-06-30 19:15:44
 * @LastEditTime: 2022-06-30 19:18:16
 * @FilePath: /vue-medweb/packages/vue-m-vaccine-prefecture/src/views/Error/index.vue
 * @Description: 统一处理错误页面
-->
<template>
  <div class="error-wrap">
    <div>{{ errorMsg }}</div>
  </div>
</template>

<script>
export default {
  name: 'Error',
  data() {
    return {
      errorMsg: this.$route.query.error_msg, // 错误信息
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.error-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: rem(375);
  height: 100vh;
  overflow: hidden;
  color: #666;
  font-weight: bold;
  font-size: 16px;
}
</style>
